module.exports = __webpack_public_path__ + "img/copyright-circle.6cbdc1e3.svg";